<template>
<div class="player-lyric">
  <scroll class="lyric-wrapper" ref="lyricList" :data="currentLyric && currentLyric.lines">
    <div>
      <div class="lyric">
        <span v-for="item in lrcJsonArr" ref="lyricLine"
            :class="{'active' : currentTime >= item.time}"
            class="lrc-content-box">{{ item.cont }}<br/>{{ item.cn }}</span>
      </div>
    </div>
  </scroll>
</div>
</template>
<script>
import Scroll from './scroll'
import {parseLyric} from '@ivy/fts/utils'

export default {
  props: ['currentTime', 'lyric'],
  data() {
    return {
      lrcJsonArr: null,
      currentIndex: 0
    }
  },
  components: {
    Scroll
  },
  async created() {
    // 转化歌词
    if (this.lyric) {
      this.lrcJsonArr = await parseLyric(this.lyric)
    }
  },
  async mounted() {
    this.currentIndex = 0
  },
  methods: {
    scrollWithMusic(currentTime) {
      if (!this.lrcJsonArr) {
        return
      }
      for (let i = this.currentIndex; i < this.lrcJsonArr.length; i++) {
        if (Math.floor(currentTime) === Math.floor(this.lrcJsonArr[i].time)) {
          this.currentIndex = i
        }
      }
      if (this.currentIndex > 3) {
        let lineEl = this.$refs.lyricLine[this.currentIndex - 3]
        this.$refs.lyricList.scrollToElement(lineEl, 1000)
      } else {
        this.$refs.lyricList.scrollToElement(0, 0, 1000)
      }
    },
  },
  watch: {
    currentTime: 'scrollWithMusic'
  }
}
</script>
<style lang="less">
@import url(../../project.less);
.player-lyric{
  .default-background-color;
  height: calc(52vh);
  overflow: hidden;
  position: relative;
  .cells;
  justify-content: center;
  .lrc-content-box{
    font: .8rem/1.74em @fontStack;
    text-align: center;
    display: flex;
    justify-content: center;
    &.active {
      color: @primary;
    }
  }
}
</style>
